import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { ensurePrimeOverlayPatch } from './app/_util/prime-overlay-patch';
import { appConfig } from './app/app.config';

console.log('[main.ts] Bootstrapping Angular app...');

ensurePrimeOverlayPatch();

bootstrapApplication(AppComponent, appConfig)
  .then(() => console.log('[main.ts] Angular bootstrapped successfully.'))
  .catch(err => console.error('[main.ts] Error bootstrapping Angular app:', err));
